import { AddressRequirement } from "./types";

/**
 * determines the address requirement for a list of inventoryresults
 * @param cart
 */
export const locationRequirement = (
    cart: InventoryResult[] | null
): AddressRequirement => {
    let requirement: AddressRequirement = AddressRequirement.None;

    if (!cart) {
        return requirement;
    }

    for (let i = 0; i < cart.length; i++) {
        if (cart[i].AddressRequirement > requirement) {
            requirement = cart[i].AddressRequirement;
        }
    }

    return requirement;
};
